import axios from 'axios'
import qs from 'qs'
import * as serverConfig from './server-config'

let config = serverConfig.getConfig()

export let httpClient = axios.create()

const requestHeader = {
	URL_ENCODE_CONTENT_TYPE: {'Content-Type': 'application/x-www-form-urlencoded'},
	JSON_CONTENT_TYPE: {'Content-Type': 'application/json'},
	PLAIN_TEXT_CONTENT_TYPE: {'Content-Type': 'text/plain'}
}

export function getAppVersion({type}) {
	return httpClient.get(`${config.serverHost}/api/broker-service/app/version/latest`, {
		params: {type}
	})
}

export function getRankingData(shareId) {
	return httpClient.get(`${config.serverHost}/api/broker-service/rank/share-info/${shareId}`)
}

export function getBusinessCard(businessCardId) {
	return httpClient.get(`${config.serverHost}/api/broker-service/biz-card/share/${businessCardId}`)
}

export function getArticleDetail(id) {
	return httpClient.get(`${config.serverHost}/api/info/query/data/${id}`)
}

export function getRelatedArticle(id) {
	return httpClient.get(`${config.serverHost}/api/info/list/article/relate/${id}`)
}

export async function getCaptchaBase64() {
	return httpClient.get(`${config.serverHost}/api/auth-service/captcha/oauth`)
}

export async function getMessageCode(mobile, picCode, captchaId) {
	let param = qs.stringify({
		mobile: mobile,
		code: picCode,
		captchaId: captchaId
	})
	return httpClient.post(`${config.serverHost}/api/auth-service/login/cors/ticket`, param, {headers: requestHeader.URL_ENCODE_CONTENT_TYPE})
}

export function verifyMobile(mobile, ticket) {
	let param = qs.stringify({
		mobile: mobile,
		ticket: ticket
	})
	return httpClient.post(`${config.serverHost}/api/auth-service/login/portal`, param, {headers: requestHeader.URL_ENCODE_CONTENT_TYPE})
}

export function postInvite(mobile, inviterId) {
	let param = qs.stringify({
		mobile: mobile,
		inviterId: inviterId
	})
	return httpClient.post(`${config.serverHost}/api/broker-service/invite/bind`, param, {headers: requestHeader.URL_ENCODE_CONTENT_TYPE})
}

export function postAStockEventList(data) {
	return httpClient.post(`${config.robotServer}/api/robot/proxy/1.0.0/cors/operation/general/jg_event/list`, data, {headers: requestHeader.JSON_CONTENT_TYPE})
}

export function getStrategyEvent() {
	return httpClient.get(`${config.robotServer}/api/robot/proxy/1.0.0/cors/operation/general/strategy/event`)
}

export function getPerformance(id, startDate, endDate) {
	return httpClient.get(`${config.robotServer}/api/robot/proxy/1.0.0/cors/investment/plan/stock/performance/${id}?startDate=${startDate}&endDate=${endDate}`)
}

export function getDigitalCertInfo(empId) {
    return httpClient.get(`${config.serverHost}/api/broker-service/sac/digital-cert-info?empId=${empId}`)
}



// WEBPACK FOOTER //
// ./src/common/js/rest-api.js